// extracted by mini-css-extract-plugin
export default {"selected":"TabCallPass_selected__qMBSF"};